import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/auth/user.service';

@Component({
    selector: 'app-forgot-pass',
    templateUrl: './forgot-pass.component.html',
    styles: []
})
export class ForgotPassComponent implements OnInit {
    formModel = {
        Email: '',
    }

    constructor(
        private toastr: ToastrService,
        private userService: UserService,
    ) { }

    ngOnInit() {
    }

    onSubmit(form: NgForm) {
        document.getElementById('page-loader').style.display = "block";
        this.userService.forgotPass(form.value).subscribe(
            (res: any) => {
                this.toastr.success("Thành công");
                window.location.href = "/techbyte/admin/login";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader').style.display = "none";
            }
        );
    }
}